import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgPlugins = (_a) => {
  var _b = _a, { size, title = "Plugins" } = _b, props = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36",
    width: size,
    height: size,
    "data-icon-name": title,
    "aria-label": title,
    role: "presentation"
  }, props), /* @__PURE__ */ React.createElement("path", {
    fill: "#142739",
    d: "M17.625 1.077L3 9.525l15 8.656 15-8.656-14.625-8.448a.75.75 0 00-.75 0z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#435261",
    d: "M14.25 3.212v5.22c0 1.242 1.68 2.25 3.75 2.25 2.07 0 3.75-1.008 3.75-2.25v-5.22h-7.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#142739",
    d: "M18 5.431c2.071 0 3.75-1.007 3.75-2.25 0-1.242-1.679-2.25-3.75-2.25-2.071 0-3.75 1.008-3.75 2.25 0 1.243 1.679 2.25 3.75 2.25z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#32CBCB",
    d: "M33 9.525l-15 8.656v17.317l14.61-8.37a.75.75 0 00.376-.65L33 9.524z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#28A2A2",
    d: "M32.865 22.433l-4.547-2.625c-1.076-.62-2.787.33-3.825 2.123-1.037 1.794-1.002 3.75.076 4.373l4.546 2.625 3.75-6.496z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#32CBCB",
    d: "M32.939 26.806c1.035-1.793 1.002-3.75-.074-4.372-1.076-.622-2.788.329-3.823 2.122-1.036 1.794-1.003 3.752.073 4.373 1.077.621 2.788-.329 3.824-2.123z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#435261",
    d: "M18 35.501v-17.32L3 9.525l-.053 16.836a.75.75 0 00.375.652L18 35.5z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#2C3C4D",
    d: "M6.884 28.928l4.547-2.625c1.076-.62 1.109-2.579.075-4.372-1.034-1.794-2.747-2.745-3.825-2.123l-4.547 2.625 3.75 6.495z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#435261",
    d: "M6.884 28.928c1.076-.62 1.11-2.579.074-4.372-1.036-1.794-2.748-2.744-3.824-2.123-1.076.622-1.11 2.58-.074 4.373 1.036 1.793 2.748 2.744 3.824 2.122z"
  }));
};
var Plugins = withIcon(SvgPlugins);

export { Plugins as default };
//# sourceMappingURL=Plugins.es.js.map
